const getPreviousWeek = () => {
    const today = new Date();
    const prevMonday = new Date(today.setDate(today.getDate() - today.getDay() - 6)); // Previous Monday
    const prevSunday = new Date(today.setDate(prevMonday.getDate() + 6)); // Previous Sunday
    
    return { start: prevMonday, end: prevSunday };
  };

  export default getPreviousWeek